import { Instance, SnapshotOut, types } from 'mobx-state-tree'

export const OnboardingStoreModel = types
  .model('OnboardingStore')
  .props({
    currentStep: types.optional(types.number, 1),
    direction: types.optional(types.number, 0),
    selectedSeriesIds: types.optional(types.array(types.string), []),
    selectedTopicIds: types.optional(types.array(types.string), []),
    isCompleting: types.optional(types.boolean, false),
    error: types.optional(types.maybeNull(types.string), null),
  })
  .actions((self) => ({
    setCurrentStep(step: number) {
      self.currentStep = step
    },
    setDirection(direction: number) {
      self.direction = direction
    },
    navigateStep(step: number, direction: number) {
      self.direction = direction
      self.currentStep = step
    },
    selectSeries(id: string) {
      if (!self.selectedSeriesIds.includes(id)) {
        self.selectedSeriesIds.push(id)
      }
    },
    deselectSeries(id: string) {
      const index = self.selectedSeriesIds.indexOf(id)
      if (index > -1) {
        self.selectedSeriesIds.splice(index, 1)
      }
    },
    toggleSeries(id: string) {
      if (self.selectedSeriesIds.includes(id)) {
        this.deselectSeries(id)
      } else {
        this.selectSeries(id)
      }
    },
    selectTopic(id: string) {
      if (!self.selectedTopicIds.includes(id)) {
        self.selectedTopicIds.push(id)
      }
    },
    deselectTopic(id: string) {
      const index = self.selectedTopicIds.indexOf(id)
      if (index > -1) {
        self.selectedTopicIds.splice(index, 1)
      }
    },
    toggleTopic(id: string) {
      if (self.selectedTopicIds.includes(id)) {
        this.deselectTopic(id)
      } else {
        this.selectTopic(id)
      }
    },
    setIsCompleting(value: boolean) {
      self.isCompleting = value
    },
    setError(error: string | null) {
      self.error = error
    },
    reset() {
      self.currentStep = 1
      self.direction = 0
      self.selectedSeriesIds.clear()
      self.selectedTopicIds.clear()
      self.isCompleting = false
      self.error = null
    },
  }))

type OnboardingStoreType = Instance<typeof OnboardingStoreModel>
export interface OnboardingStore extends OnboardingStoreType {}
type OnboardingStoreSnapshotType = SnapshotOut<typeof OnboardingStoreModel>
export interface OnboardingStoreSnapshot extends OnboardingStoreSnapshotType {}
export const createOnboardingStoreDefaultModel = () =>
  types.optional(OnboardingStoreModel, {})
